import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  ElementRef,
  Input,
  OnDestroy
} from '@angular/core';
import DMSVideo from '@web-components/dms';
import videojs from 'video.js';

@Component({
  selector: 'app-dms-video-player',
  templateUrl: './dms-video-player.component.html',
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class DmsVideoPlayerComponent implements AfterViewInit, OnDestroy {
  @Input() dmsApi: string;
  @Input() dmsIds: string;

  showWebComponent = false;
  private destroyed = false;

  constructor(
    private elementRef: ElementRef,
    private cdr: ChangeDetectorRef
  ) {}

  ngAfterViewInit() {
    this.showWebComponent = true;
    this.cdr.detectChanges();

    setTimeout(() => {
      if (this.destroyed) {
        return;
      }
      const vid = this.elementRef.nativeElement.querySelector(`video[id="vid-${this.dmsIds}"]`);
      if (!vid || !videojs.getPlayer(vid.id)) {
        if (DMSVideo && typeof DMSVideo === 'function') {
          DMSVideo();
        }
      }
    }, 200);
  }

  ngOnDestroy() {
    this.destroyed = true;
    this.disposePlayers();
    // Remove `kit-dms-video` elements to force cleanup of internal VideoJS players
    const kitDmsVideos = this.elementRef.nativeElement.querySelectorAll('kit-dms-video');
    kitDmsVideos.forEach((el: Element) => el.remove());
  }

  private disposePlayers() {
    if (this.dmsIds) {
      const playerId = `vid-${this.dmsIds}`;
      const player = videojs.getPlayer(playerId);
      if (player) {
        player.dispose();
      }
    }
  }
}
